import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiLinkedin, FiMapPin } from 'react-icons/fi';
import { FaWhatsapp, FaTelegram } from 'react-icons/fa6';

const Footer = () => {
    return (
        <footer className="relative bg-[#05060a] text-gray-400 px-6 md:px-16 pt-16 pb-10 text-sm border-t border-white/10">
            <div className="max-w-7xl mx-auto">
                <div className="grid md:grid-cols-12 gap-10 mb-12">
                    <div className="md:col-span-4">
                        <div className="text-red-500 font-mono text-lg font-semibold mb-3">
                            &lt;SiberLab ID/&gt;
                        </div>
                        <p className="leading-relaxed text-gray-400 mb-5">
                            Strengthening Indonesia's cybersecurity posture through education,
                            training, and professional services.
                        </p>
                        <div className="text-xs text-gray-500 leading-relaxed mb-5">
                            <p className="font-semibold text-gray-300 mb-1.5">PT Siberlab Teknologi Indonesia</p>
                            <p className="flex items-start gap-2">
                                <FiMapPin className="mt-0.5 shrink-0 text-red-500/70" />
                                <span>
                                    Sovereign Plaza Lantai 12, Jl. TB Simatupang No. 36,
                                    <br />
                                    Jakarta Selatan, Indonesia
                                </span>
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <a href="https://t.me/siberlabid" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-500/40 flex items-center justify-center transition"><FaTelegram /></a>
                            <a href="https://wa.me/6281234868640" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-500/40 flex items-center justify-center transition"><FaWhatsapp /></a>
                            <a href="https://www.instagram.com/siberlab.id" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-500/40 flex items-center justify-center transition"><FiInstagram /></a>
                            <a href="http://www.linkedin.com/in/siberlab.id" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-500/40 flex items-center justify-center transition"><FiLinkedin /></a>
                        </div>
                    </div>
                    <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
                        <div>
                            <h4 className="text-white font-display font-semibold mb-3">Services</h4>
                            <ul className="space-y-2">
                                <li><Link to="/services/cybersecurity-training" className="hover:text-white transition">Cybersecurity Training</Link></li>
                                <li><Link to="/services/ctf-vendor" className="hover:text-white transition">CTF Organizer</Link></li>
                                <li><Link to="/services/red-team" className="hover:text-white transition">Red Team & Pentest</Link></li>
                                <li><a href="https://akademi.siberlab.id/" target="_blank" rel="noreferrer" className="hover:text-white transition">Akademi Siber</a></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-display font-semibold mb-3">Company</h4>
                            <ul className="space-y-2">
                                <li><a href="/#about" className="hover:text-white transition">About Us</a></li>
                                <li><a href="/#testimonials" className="hover:text-white transition">Testimonials</a></li>
                                <li><a href="/#contact" className="hover:text-white transition">Contact</a></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-display font-semibold mb-3">Resources</h4>
                            <ul className="space-y-2">
                                <li><a href="https://blog.siberlab.id" target="_blank" rel="noreferrer" className="hover:text-white transition">Blog</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="section-divider mb-6" />

                <div className="flex flex-col md:flex-row justify-between items-center text-xs gap-4 text-gray-500">
                    <p>© {new Date().getFullYear()} PT Siberlab Teknologi Indonesia. All rights reserved.</p>
                    <div className="flex gap-5">
                        <a href="#privacy" className="hover:text-white transition">Privacy Policy</a>
                        <a href="#terms" className="hover:text-white transition">Terms of Service</a>
                        <a href="#cookie" className="hover:text-white transition">Cookie Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
